var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgChangePlan = function SvgChangePlan(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 80 81"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    fillRule: "evenodd",
    d: "M41 38.828c6.075 0 11-4.925 11-11s-4.925-11-11-11-11 4.925-11 11 4.925 11 11 11m0 2c7.18 0 13-5.82 13-13s-5.82-13-13-13-13 5.82-13 13 5.82 13 13 13M23.961 64.703c5.523 0 10-4.477 10-10s-4.477-10-10-10-10 4.477-10 10 4.478 10 10 10m0 2c6.628 0 12-5.372 12-12 0-6.627-5.372-12-12-12-6.627 0-12 5.373-12 12 0 6.628 5.373 12 12 12M56.039 64.703c5.522 0 10-4.477 10-10s-4.478-10-10-10-10 4.477-10 10 4.477 10 10 10m0 2c6.627 0 12-5.372 12-12 0-6.627-5.373-12-12-12-6.628 0-12 5.373-12 12 0 6.628 5.372 12 12 12",
    clipRule: "evenodd"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    fillRule: "evenodd",
    d: "M50.512 20.331a1 1 0 0 1 .057 1.413l-9.643 10.459a1 1 0 0 1-1.394.074l-4.903-4.29a1 1 0 0 1 1.317-1.506l4.17 3.65 8.983-9.742a1 1 0 0 1 1.413-.058",
    clipRule: "evenodd"
  })));
};
export default SvgChangePlan;